import { render, staticRenderFns } from "./SchoolFiltersSidebar.vue?vue&type=template&id=735cb253&"
import script from "./SchoolFiltersSidebar.vue?vue&type=script&lang=js&"
export * from "./SchoolFiltersSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports